import React from 'react';

export default function VideoLogo() {
  return (
    <img src="https://firebasestorage.googleapis.com/v0/b/protst.appspot.com/o/photos%2Flogo.png?alt=media&token=882f5ff4-949f-4fa7-a68f-5f0219389361" width="106" height="106"/>
  );
}
